import script from "./LiveMessageTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./LiveMessageTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./LiveMessageTemplate.vue?vue&type=style&index=0&id=4d1552b1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d1552b1"]])

export default __exports__